/**
 * Plugin registry for SmartResponse.
 *
 * Plugins register themselves via Smart.registerPlugin(name, initFn).
 * Core calls initPlugins() during Smart.start() which invokes each
 * registered plugin with its config section and emits lifecycle events.
 *
 * Usage (inside a plugin file):
 *   Smart.registerPlugin('modals', function(config) { ... })
 */

import { emit } from './event-system';

const plugins = {};

export function registerPlugin(name, initFn) {
    if (plugins[name]) {
        console.warn(`[Smart] Plugin '${name}' is already registered. Overwriting.`);
    }
    plugins[name] = initFn;
}

/**
 * Initialize all registered plugins.
 * @param {object} config - The full Smart config object. Each plugin receives its own section.
 */
export function initPlugins(config) {
    Object.keys(plugins).forEach(name => {
        // Map camelCase plugin name to snake_case config key
        const configKey = name.replace(/([A-Z])/g, '_$1').toLowerCase();
        const pluginConfig = config[configKey] || config[name] || {};

        try {
            emit(`plugin:${name}:before:init`, pluginConfig);
            plugins[name](pluginConfig);
            emit(`plugin:${name}:init`, pluginConfig);
        } catch (e) {
            console.error(`[Smart] Error initializing plugin '${name}':`, e);
        }
    });
}

export function getRegisteredPlugins() {
    return Object.keys(plugins);
}

export default { registerPlugin, initPlugins, getRegisteredPlugins };
